import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlimtalkApiV2 } from '../../../lib/api/alimtalk/AlimtalkApiV2';
import { ErrorResponseType, extractErrorMessage } from '../../../lib/utils/checkErrorResponse';
import toastMsg from '../../../lib/toastMsg';
import { alimtalkToastMsg } from '../../../constants/service/toastMsg/alimtalkToastMsg';
import { AlimtalkSendResponse, TestAlimtalkSendDto } from '../../../types/alimtalk/send';

export const useTestAlimtalkSendMutation = (): UseMutationResult<
  AlimtalkSendResponse,
  ErrorResponseType,
  TestAlimtalkSendDto
> =>
  useMutation({
    mutationFn: (dto: TestAlimtalkSendDto) => AlimtalkApiV2.testSend(dto),
    onSuccess: () => {
      toastMsg.success(alimtalkToastMsg.TEST_SEND_REQUEST_SUCCESS);
    },
    onError: (error) => {
      // 백엔드 조합 검증 400 사유(errors[0].message)를 우선 표시 — 전역 모달은 이 코드를 다루지 않음
      toastMsg.error(extractErrorMessage(error, alimtalkToastMsg.TEST_SEND_REQUEST_ERROR), error);
    },
  });
